import { WorkTask } from "../../types/ganttChart";
import labels from "../../utils/labels";
import drawerStyles from "../../styles/drawer.module.css";
import LabeledSection from "../UI/LabeledSection";

const SubTasksList = ({ task }: { task: WorkTask }) => {
  return (
    <LabeledSection title={labels.tasks}>
      <section className={drawerStyles.subTasksList}>
        {task.subTasks.map((subTask, index) => (
          <div key={index} className={drawerStyles.subTaskWrapper}>
            <h4 style={{ font: "var(--font-h4)", width: "120px" }}>{`${labels.task} ${index + 1}`}</h4>
            {subTask.description}
          </div>
        ))}
      </section>
    </LabeledSection>
  );
};

export default SubTasksList;